import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TemplateDeliveryPath} from '../model/template-delivery-path';
import {AppConfig} from '../shared/app-config';
import {environment} from '../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError, map, publishReplay, refCount} from 'rxjs/operators';
import {factory} from '../shared/app-logging';
import {ErrorDataService} from './error-data.service';

const logger = factory.getLogger('TemplateDeliveryPathsService');


@Injectable({
  providedIn: 'root'
})
export class TemplateDeliveryPathsService {

  private templateDeliveryPaths: Observable<TemplateDeliveryPath[]>;
  private templateDeliveryPathsLastCallError = false;

  constructor(private httpClient: HttpClient) {
  }

  public findTemplateDeliveryPaths(): Observable<TemplateDeliveryPath[]> {
    if (this.templateDeliveryPaths && !this.templateDeliveryPathsLastCallError) {
      logger.debug('findTemplateDeliveryPaths: Cache hit.');
    }
    this.templateDeliveryPaths = (this.templateDeliveryPaths && !this.templateDeliveryPathsLastCallError) ?
      this.templateDeliveryPaths : this.fetchTemplateDeliveryPaths();
    return this.templateDeliveryPaths;
  }

  private fetchTemplateDeliveryPaths(): Observable<TemplateDeliveryPath[]> {
    return this.httpClient.get(environment.contentLibraryApiBaseUrl + AppConfig.urlTemplateDeliveryPaths).pipe(map(
      response => {
        const deliveryPaths = [];

        for (const item of response['data']) {
          deliveryPaths.push(new TemplateDeliveryPath(item.delivery_path));
        }

        logger.debug(`findTemplateDeliveryPaths: ${deliveryPaths.length} delivery paths fetched from REST`);
        this.templateDeliveryPathsLastCallError = false;
        return deliveryPaths;
      }
      ), catchError((err: Error | HttpErrorResponse) => {
        const message = `In TemplateDeliveryPathsService.findTemplateDeliveryPaths().`;
        this.templateDeliveryPathsLastCallError = true;
        return throwError(ErrorDataService.overLoadError(err, message));
      }),
      publishReplay(1),
      refCount());
  }

}
